module.exports = __webpack_public_path__ + "img/weylchem-1.a323527e.png";